export const LESSOR_RESPONSIBILITY = {
    title: '附加出租人责任保险条款B款',
    subtitle: '保险责任',
    protocols: [
        {
            list: [
                {
                    order: '第一条',
                    context: '在保险期间内，被保险人出租的，位于主险载明地址的房屋因发生下列事故，造成他人人身伤亡或财产损失，依法应由被保险人承担的经济赔偿责任，保险人按照本附加险合同的约定负责赔偿：',
                    details: [
                        { regulations: [
                            '（一）房屋本身的质量问题导致的结构损坏或者倒塌；',
                            '（二）火灾、爆炸；',
                            '（三）水管爆裂漏水，电器线路或电器设备漏电、短路；',
                            '（四）燃气泄漏；',
                            '（五）固定在房屋建筑物上的生活设施非人为原因脱落。'
                        ] }
                    ]
                },
                {
                    order: '第二条',
                    context: '保险事故发生后，被保险人因保险事故而被提起仲裁或诉讼的，对应由被保险人支付的仲裁或诉讼费用以及事先经保险人书面同意支付的其他必要的、合理的费用（以下统称“法律费用”），保险人按照本附加险合同的约定也负责赔偿。'
                }
            ]
        },
        {
            intro: '责任免除',
            list: [
                { order: '第三条', context: '被保险人已知房屋存在安全隐患却未及时修理的情形下发生的损失、费用和责任，保险人不负责赔偿，但不可抗力造成的损失、费用和责任不在此限。' }
            ]
        },
        {
            intro: '责任限额',
            list: [
                { order: '第四条', context: '责任限额包括每次事故每人伤亡责任限额、每次事故责任限额、累计责任限额，具体由投保人与保险人双方协商确定，并在保险单中载明。' }
            ]
        },
        {
            intro: '赔偿处理',
            list: [
                {
                    order: '第五条',
                    context: '发生保险责任范围内的损失，保险人按照下列约定计算赔偿：',
                    details: [
                        { text: '（一）对每次事故中每人的人身损害，保险人按照《最高人民法院关于审理人身损害赔偿案件适用法律若干问题的解释》规定的赔偿项目和赔偿标准进行计算。' },
                        { text: '（二）对每次事故中的财产损失，保险人按实际损失进行赔偿。' },
                        { text: '（三）保险人对每次保险事故中所有的人身损害和财产损失赔偿的保险金总和不超过每次事故责任限额；对多次保险事故中所有的人身损害和财产损失赔偿的保险金总和不超过累计责任限额。' }
                    ]
                },
                { order: '第六条', context: '除另有约定外，对每次事故法律费用的赔偿金额，保险人在第五条计算的赔偿金额以外另行计算，最高不超过每次事故责任限额的10%。' }
            ]
        },
        {
            intro: '其他事项',
            list: [
                { order: '第七条', context: '本附加险条款未尽事宜，以主险条款的约定为准；本附加险条款与主险条款若有相抵触之处，以本附加险条款的约定为准。' }
            ]
        }
    ]
}